import React from "react";
import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import "@companion-core/web/src/Assets/Styles/scss/inputlabel.scss";

interface Props {
  label: string;
  icon?: string;
  htmlFor?: string;
  id?: string;
}

const InputLabel = ({ label, icon, htmlFor, id }: Props) => {
  const content = (
    <>
      {icon && (
        <FontIcon
          aria-hidden={true}
          data-testid="input-label__icon"
          name={icon}
          className="body-text-5 margin-right-8"
        />
      )}
      <span className="body-text-5 margin-bottom-8">{label}</span>
    </>
  );

  return htmlFor ? (
    <label
      id={id}
      htmlFor={htmlFor}
      className="input-label__containter d-flex"
      style={{ cursor: "pointer" }}>
      {content}
    </label>
  ) : (
    <div id={id} className="input-label__containter d-flex">
      {content}
    </div>
  );
};

export default InputLabel;
